import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { FormGroup, FormControl, HelpBlock } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import { Link } from 'react-router-dom';

// Import Selectors
import { requestRemind } from '../../AuthActions';

class RemindPage extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      success: false,
      errors: null,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderField = this.renderField.bind(this);
  }

  handleSubmit(data) {
    const { valid } = this.props;
    if (!valid) {
      return;
    }
    this.setState({ loading: true, success: false, errors: null });
    this.props.dispatch(requestRemind(data.email))
      .then(
        () => {
          this.setState({ loading: false, success: true, errors: null });
        },
        (errors) => {
          const e = errors.data || errors;
          if (e.message) {
            e._error = e.message;
          } else if (e.email) {
            e.message = e.email;
          }
          this.setState({ loading: false, success: false, errors: e });
          throw new SubmissionError(e);
        },
      );
  }

  renderField({
    input, label, type, meta: { touched, error },
  }) {
    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup validationState={validationState}>
        <FormControl {...input} placeholder={label} type={type} />
        <FormControl.Feedback />
        {touched && error && <HelpBlock className="text-left">{error}</HelpBlock>}
      </FormGroup>
    );
  }

  render() {
    const { handleSubmit, submitting } = this.props;
    const { errors, success, loading } = this.state;
    if (success) {
      return (
        <div>
          Please check your email and follow the instructions.
          <p />
          <div>
            <Link to="/signin/form"><Fa name="arrow-left" /> Login</Link>
          </div>
        </div>
      );
    }
    return (
      <div>
        <p className="text-left">Please enter your email to get the reset password link</p>

        <form onSubmit={handleSubmit(this.handleSubmit)}>
          <Field disabled={submitting} name="email" type="text" component={this.renderField} label="Your Email" />
          {errors !== null && errors.message !== undefined && <p className="text-danger">{errors.message}</p>}
          <button type="submit" disabled={submitting || loading} className="btn btn-primary btn-lg btn-default btn-block">
            Reset Password
          </button>
        </form>
        <p />
        <div>
          <Link to="/signin/form"><Fa name="times-circle" /> Cancel</Link>
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps() {
  return {};
}

RemindPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onLoading: PropTypes.func,
  onSuccess: PropTypes.func,
  location: PropTypes.object.isRequired,
};
RemindPage.defaultProps = {
  onLoading: () => {},
  onSuccess: () => {},
};

RemindPage.contextTypes = {
  router: PropTypes.object,
};

const validate = (values) => {
  const errors = {};
  if (!values.email) {
    errors.email = 'Please enter your email';
  }
  return errors;
};


const RemindPasswordForm = reduxForm({
  form: 'remindPasswordForm',
  validate,
})(RemindPage);

export default connect(mapStateToProps)(RemindPasswordForm);
